import React from 'react';

export const LoadingIndicator: React.FC = () => {
  return <div className="loading-indicator">Processing...</div>;
};
